module.exports = __webpack_public_path__ + "img/code.9e8678e2.svg";